export default function StatusBadge({

  status = ""
}) {

  const value =
    String(status)
      .toLowerCase();

  const styles = {

    approved:
      "bg-green-100 text-green-700",

    pending:
      "bg-yellow-100 text-yellow-700",

    rejected:
      "bg-red-100 text-red-700",

    paid:
      "bg-blue-100 text-blue-700"
  };

  return (

    <span
      className={`

        px-4
        py-2
        rounded-full
        text-xs
        font-bold
        capitalize

        ${

          styles[value]

          ||

          "bg-gray-100 text-gray-700"
        }
      `}
    >
      {status}
    </span>
  );
}